import { EmpyreanModelType } from './empyrean.interface';

/**
 * The six Entity Balancing Postings on IRRM 2's `Key Accounts` tab (PROD-647), in its column order —
 * `key` is the field on {@link EmpyreanModelTypeSettings}, `header` is the tab's own row-2 text,
 * verbatim from Luke's golden template.
 */
export const empyreanKeyAccountRoles = [
  { key: 'assetBalancingAccountNum', header: 'Asset Balancing' },
  { key: 'liabBalancingAccountNum', header: 'Liab Balancing' },
  { key: 'equityBalancingAccountNum', header: 'Equity Balancing' },
  { key: 'eqEarningsCreditAccountNum', header: 'Eq Earnings Credit' },
  { key: 'eqFvCompIncAccountNum', header: 'Eq FV Comp. Inc.' },
  { key: 'ociDeferredTaxesAccountNum', header: 'OCI Deferred Taxes' }
] as const;
export type EmpyreanKeyAccountKey = (typeof empyreanKeyAccountRoles)[number]['key'];

/**
 * The chart accounts the four `HIST_*` Exo Import equations name (PROD-647 item 4), by account number:
 * the equations are written with the mnemonic the client's own chart carries for each. Independent of
 * one another, unlike the key accounts — a null leaves only its own rows out.
 */
export type EmpyreanHistoricalMetricAccountKey =
  | 'netInterestIncomeAccountNum'
  | 'nmdRollupAccountNum'
  | 'cdRollupAccountNum';

/**
 * One model type's defaults (`emp.EmpyreanModelTypeSettings`, PROD-647): the tax rate and CPI a client
 * inherits until it sets its own, and the model's six key accounts.
 *
 * ⚠ **Null means nobody has decided**, never zero. CU ALM's key accounts and HIST_* accounts stay null until Greg gives them;
 * Generate warns and leaves the rows out rather than writing a guess. Rates are DECIMALS (0.29 = 29%).
 * Account numbers are strings, like every `almAccountNum` in the app (the column is bigint), and are
 * all six or none — a CHECK constraint.
 */
export type EmpyreanModelTypeSettings = {
  modelType: EmpyreanModelType;
  defaultTaxRate: number | null;
  defaultCpi: number | null;
} & Record<EmpyreanKeyAccountKey | EmpyreanHistoricalMetricAccountKey, string | null>;
